import { recursiveFreeze } from '@philips-emr/tws-utils';

import { AuthenticationConfiguration } from './auth/authentication-service';

let contextName = '';
let authConfig: Readonly<AuthConfig> | null = null;

let authenticationConfiguration: Readonly<AuthenticationConfiguration> | null = null;

interface ConfigurationData {
  contextName: string;
}

export interface AuthConfig {
  loginRoute: string;

  clientId: string;
  // clientSecret, gonna be provided by backend
  endpoints: {
    resfresh: EndpointConfig;
    revoke: EndpointConfig;
  };
}

export interface EndpointConfig {
  url: string;
  method?: string;
}

function init(data: ConfigurationData): void {
  const isEmpty = !(data.contextName || '').trim();
  contextName = isEmpty ? '' : `/${data.contextName}`.replace(new RegExp('//+', 'g'), '/');
}

function setAuthConfig(config: AuthConfig): void {
  if (!authConfig) {
    authConfig = recursiveFreeze(config);
  }
}

function getAuthConfig(): AuthConfig | null {
  return authConfig;
}

function getAuthenticationConfiguration(): AuthenticationConfiguration | null {
  return authenticationConfiguration;
}

function setAuthenticationConfiguration(configuration: AuthenticationConfiguration): void {
  if (authenticationConfiguration) {
    throw Error('[Configuration Service]: Authentication Configuration was already initialized.');
  }

  authenticationConfiguration = recursiveFreeze(configuration);
}

function getContextName(): string {
  return contextName;
}

export {
  getAuthConfig,
  getAuthenticationConfiguration,
  getContextName,
  init,
  setAuthConfig,
  setAuthenticationConfiguration,
};

export default {
  getAuthConfig,
  getAuthenticationConfiguration,
  getContextName,
  init,
  setAuthConfig,
  setAuthenticationConfiguration,
};
